import * as React from 'react';
import { IReferral } from '../../../../models/IReferral';
import { CustomButton, ButtonType } from "soprasteria-ui-library";
import { useHistory } from 'react-router-dom';
import { ReferralActionButtons } from './ReferralActionButtons';
import './ReferralBottomButtons.scss';

interface IReferralFooterButtons {
    referral?: IReferral;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
    gotTreatmentsReported?: boolean;
    isParaply: boolean;
}

export const ReferralFooterButtons: React.FunctionComponent<IReferralFooterButtons> = ({ referral, changeSuccessMessage, changeErrorMessage, getReferral, gotTreatmentsReported, isParaply }) => {
    const history = useHistory();

    return (
        <>
            <div className="row">
                <div className="col-6 text-left">
                    <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                </div>
                <div className="col-6 text-right">
                    <ReferralActionButtons changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getReferral={getReferral} referral={referral} gotTreatmentsReported={gotTreatmentsReported} isParaply={isParaply} />
                </div>
            </div>
        </>
    )
}